import { render, staticRenderFns } from "./robotInfoList.vue?vue&type=template&id=48d80567&"
import script from "./robotInfoList.vue?vue&type=script&lang=js&"
export * from "./robotInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d80567')) {
      api.createRecord('48d80567', component.options)
    } else {
      api.reload('48d80567', component.options)
    }
    module.hot.accept("./robotInfoList.vue?vue&type=template&id=48d80567&", function () {
      api.rerender('48d80567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/robotInfoList.vue"
export default component.exports